import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class MatPaginatorIntlTranslated extends MatPaginatorIntl {

  constructor(private readonly translate: TranslateService) {
    super();
    this.translateLabels();

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
  }

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant('common.paginator.itemsPerPage');
    this.nextPageLabel = this.translate.instant('common.paginator.nextPage');
    this.previousPageLabel = this.translate.instant('common.paginator.previousPage');
    this.firstPageLabel = this.translate.instant('common.paginator.firstPage');
    this.lastPageLabel = this.translate.instant('common.paginator.lastPage');

    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('common.paginator.rangePage1', { length });
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return this.translate.instant('common.paginator.rangePage2', { startIndex: startIndex + 1, endIndex, length });
  }
}
